import { render, staticRenderFns } from "./vlogs.vue?vue&type=template&id=0d8ac0c9&scoped=true&"
import script from "./vlogs.vue?vue&type=script&lang=js&"
export * from "./vlogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8ac0c9",
  null
  
)

export default component.exports